
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import OsEntityToolbar from '@/components/core/OsEntityToolbar.vue';
import OsEntityForm from '@/components/core/OsEntityForm.vue';
import { AppuserState, IExtendedAppuser } from '@/models/application';
import {
  EntityFormFieldType,
  IEntityFormField,
  IKeyValuePair
} from '@/models/core';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import { visibleLanguages } from '@/lang';

@Component({
  components: { OsSheetContent, OsEntityForm, OsEntityToolbar }
})
export default class OsAppuserForm extends Vue {
  @PropSync('appDirtyUtil', { required: true })
  internalAppDirtyUtil!: AppDirtyUtil;
  @Prop({ required: false, default: false })
  isCreateForm!: boolean;
  @Prop({ required: false, default: false })
  showIsAdminFlag!: boolean;
  @PropSync('value', { required: true })
  internalValue!: IExtendedAppuser;

  @Prop({ default: 'Create new Appuser' })
  titleCreateForm!: string;
  @Prop({ default: 'Appuser' })
  titleExistingForm!: string;
  @Prop({ default: '' })
  textState!: string;
  @Prop({ default: 'Active' })
  textAppuserStateActive!: string;
  @Prop({ default: 'Inactive' })
  textAppuserStateInactive!: string;
  @Prop({ default: 'Language' })
  textLanguagecode!: string;
  @Prop({ default: 'Firstname' })
  textFirstname!: string;
  @Prop({ default: 'Lastname' })
  textLastname!: string;
  @Prop({ default: 'E-Mail-Address' })
  textEmailAddress!: string;

  @Prop({
    default: () =>
      visibleLanguages.map((l) => {
        return { key: l.name, value: l.code };
      })
  })
  languages!: IKeyValuePair<string, string | null>[];

  loading = false;
  formIsValid = false;

  get fields(): IEntityFormField[] {
    return [
      {
        type: EntityFormFieldType.radio,
        label: this.textState,
        propName: 'state',
        smCols: 6,
        required: true,
        radioAsRow: true,
        readonly: this.isCreateForm,
        items: [
          { key: this.textAppuserStateActive, value: AppuserState.Active },
          {
            key: this.textAppuserStateInactive,
            value: AppuserState.Inactive
          }
        ]
      },
      {
        type: EntityFormFieldType.checkbox,
        label: 'Administrator',
        smCols: 3,
        propName: 'isAdmin',
        visible: this.showIsAdminFlag
      },
      {
        type: EntityFormFieldType.select,
        label: this.textLanguagecode,
        propName: 'languagecode',
        smCols: 3,
        required: true,
        items: this.languages
      },
      {
        type: EntityFormFieldType.text,
        label: this.textFirstname,
        propName: 'firstname',
        smCols: 6,
        required: true
      },
      {
        type: EntityFormFieldType.text,
        label: this.textLastname,
        propName: 'lastname',
        smCols: 6,
        required: true
      },
      {
        type: EntityFormFieldType.email,
        label: this.textEmailAddress,
        propName: 'emailaddress',
        smCols: 12,
        required: true
      }
    ];
  }

  get isDirty() {
    return AppDirtyUtil.isDirty;
  }

  onSave() {
    this.$emit('onSave');
  }

  onDelete() {
    this.$emit('onDelete');
  }

  onUndo() {
    this.$emit('undoClicked');
  }

  openCreateNewForm() {
    this.$emit('openCreateNewForm');
  }

  mounted() {
    this.internalAppDirtyUtil.init(this.internalValue);
  }

  @Watch('internalValue', { deep: true })
  onInternalValueChanged() {
    this.internalAppDirtyUtil.update(this.internalValue);
  }
}
